import _extends from "@babel/runtime/helpers/extends";
import parseHTML, { domToReact } from 'html-react-parser';
import React from 'react';
import { ANCHOR_TAG, TARGET_BLANK } from '../constants';
function parseTextBlock(config) {
  const {
    html,
    LinkWrapper,
    useTargetBlank
  } = config;
  const options = {
    replace: domNode => {
      const {
        attribs,
        children,
        name: tagName
      } = domNode;
      if (tagName === ANCHOR_TAG) {
        const target = useTargetBlank ? TARGET_BLANK : attribs.target;
        return LinkWrapper ? /*#__PURE__*/React.createElement(LinkWrapper, _extends({}, attribs, {
          target: target
        }), domToReact(children, options)) : domNode;
      }
      return null;
    }
  };
  return parseHTML(html, options);
}
export default parseTextBlock;
//# sourceMappingURL=parse-TextBlock.js.map